import { useModal } from "context";
import { FormButton } from "reusableComponents";
import styles from "./styles.module.scss";

const SimpleConfirmationModal = ({ text }) => {
  const { closeModal } = useModal();

  return (
    <div className={styles.modalContainer}>
      <p dangerouslySetInnerHTML={{__html: text}}></p>
      <FormButton onClick={closeModal} label="OK" />
    </div>
  );
};

export default SimpleConfirmationModal;